"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAGE_LIST = void 0;
var STAGE_LIST = {
  GAT_GAME_RESULTS: 148,
  ALL_BETS: 220,
  ANSWERS_REVIEW: 146,
  BETS_CHECK: 145,
  BETS_CLOSED: 150,
  BETS_RESULTS: 240,
  CERTIFICATES: 60,
  EFFECT_STAGE: 235,
  EXERCISE: 310,
  EXERCISE_BLOCK: 320,
  EXERCISE_RESULTS: 330,
  EXERCISE_STEP: 305,
  EXPLANATION_ZONE: 250,
  FINISH: 70,
  GAME_REPORT: 147,
  GAME_RESULTS: 30,
  INTRODUCTION: 20,
  LOGIN: 10,
  MAKING_BETS: 140,
  MAP_OF_MAPS: 110,
  MAP_STEP: 105,
  POLL: 50,
  READY_TO_START: 0,
  REPORTING_TEAM: 210,
  ROUND_RESULTS: 270,
  SELECTING_ZONE: 160,
  SHOWING_MAP: 130,
  SHOWING_ZONE: 215,
  SLIDES_AFTER_EXERCISE: 340,
  SLIDES_AFTER_MAP: 170,
  SLIDES_AFTER_SCENARIO: 40,
  SLIDES_OF_EXERCISE: 310,
  SLIDES_OF_MAP: 120,
  THREAT_OPENED: 280,
  VOTING: 141,
  VOTING_CLOSED: 151,
  ZONE_CONCLUSION: 260,
  ZONE_OPENED: 230,
  ZONE_STEP: 205
};
exports.STAGE_LIST = STAGE_LIST;